<template>
  <div class="container">
    <div class="filter-container">
      <el-button
          class="filter-item"
          size="mini"
          type="primary"
          style="margin-bottom:10px"
          icon="el-icon-plus"
          @click="handleCreate"
      >添加</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="假期" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" align="center">
        <template v-slot="{row}">
          <span>{{ formatStartDate(row.DTStartTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center">
        <template v-slot="{row}">
          <span>{{ formatEndDate(row.DTEndTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="假期描述" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrDescription }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          fixed="right"
      >
        <template v-slot="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button
              v-if="row.status!='deleted'"
              size="mini"
              type="danger"
              @click="handleDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
    <el-dialog width="30%" :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false">
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="formModel"
          label-position="left"
          label-width="100px"
          style="margin-left:40px;"
          size="small"
      >
        <el-form-item label="假期名称" prop="StrTitle">
          <el-input v-model="formModel.StrTitle" placeholder="请输入假期名称" />
        </el-form-item>
        <el-form-item label="开始时间" prop="DTStartTime">
          <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="formModel.DTStartTime"
                style="width:100%"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                @change="choose"
            />
          </el-config-provider>
        </el-form-item>
        <el-form-item label="截止时间" prop="DTEndTime">
          <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="formModel.DTEndTime"
                style="width:100%"
                type="date"
                placeholder="选择日期"
                value-format="YYYY-MM-DD"
                @change="choose"
            />
          </el-config-provider>
        </el-form-item>
        <el-form-item label="假期描述">
          <el-input v-model="formModel.StrDescription" placeholder="请输入假期描述" type="textarea"/>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <div style="color:red;padding:10px 20px;text-align:left">(假期内不许借书，假期范围内的时间将不计算在借书时间内)</div>
        <div style="float: right">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="btnAddorMod">确定</el-button>
        </div>
        <p style="color: #ffffff">三阅</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import {BASE_URL} from "@/utils/constants";
export default {
  name: 'Holiday',
  computed: {
    zhCn() {
      return zhCn;
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 10,
        OrderBy: { "DTCreatedDate": -1 },
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      rules: {
        StrTitle: [
          { required: true, message: '请输入假期名称', trigger: 'blur' }
        ],
        DTStartTime: [
          { required: true, message: '请输入假期开始时间', trigger: 'change' }
        ],
        DTEndTime: [
          { required: true, message: '请输入假期结束时间', trigger: 'change' }
        ]
      },
      formModel: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    choose() {
      if (!this.formModel.DTStartTime || !this.formModel.DTEndTime) return;
      const day1 = new Date(this.formModel.DTStartTime);
      const day2 = new Date(this.formModel.DTEndTime);
      if (day2.getTime() < day1.getTime()) {
        ElMessage.error('日期选择错误');
        this.formModel.DTEndTime = '';
      }
    },
    formatStartDate(dateStr) {
      const date = new Date(dateStr);
      console.log('timezone', this.toLocalISO(date));
      return this.toLocalISO(date);
    },

    formatEndDate(dateStr) {
      const date = new Date(dateStr);
      return this.toLocalISO(date);
    },
    toLocalISO(date) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3,
        hour12: false
      });
      const parts = formatter.formatToParts(date);
      const partValues = {};
      parts.forEach(part => {
        partValues[part.type] = part.value;
      });
      const year = partValues.year;
      const month = partValues.month;
      const day = partValues.day;
      const hour = partValues.hour;
      const minute = partValues.minute;
      const second = partValues.second;
      let millisecond = partValues.fractionalSecond || '000';

      millisecond = millisecond.padEnd(3, '0');

      return `${year}-${month}-${day}`;
      // return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}+08:00`;
    },
    getList() {
      this.$axios({
        url: BASE_URL + 'holidays/search',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          this.listLoading = false;
        }
      });
    },
    handleCreate() {
      this.formModel = {};
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    toLocalISOString(date) {
      const pad = n => (n < 10 ? '0' + n : n);
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

      // 获取当前时区与 UTC 的分钟差，注意这里要取负数才是正确的偏移
      const offset = -date.getTimezoneOffset();
      const sign = offset >= 0 ? '+' : '-';
      const offsetHours = pad(Math.floor(Math.abs(offset) / 60));
      const offsetMinutes = pad(Math.abs(offset) % 60);

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${sign}${offsetHours}:${offsetMinutes}`;
    },

    btnAddorMod() {
      const parem = {
        StrDescription: this.formModel.StrDescription,
        StrTitle: this.formModel.StrTitle
      };
      const pattern = /^\d{4}-\d{2}-\d{2}$/;

      // 假设 DTStartTime 和 DTEndTime 都符合 "YYYY-MM-DD" 格式
      if (this.formModel.DTEndTime !== undefined && this.formModel.DTEndTime !== null) {
        if (pattern.test(this.formModel.DTStartTime) && pattern.test(this.formModel.DTEndTime)) {
          // 生成当天的开始和结束时间对象
          const dtStart = new Date(this.formModel.DTStartTime);
          dtStart.setHours(0, 0, 0, 0);
          const dtEnd = new Date(this.formModel.DTEndTime);
          dtEnd.setHours(23, 59, 59, 0); // 修改为 0，而不是 999

          // 利用原生 API 生成 ISO 格式字符串（含时区）
          parem.DTStartTime = this.toLocalISOString(dtStart);
          parem.DTEndTime = this.toLocalISOString(dtEnd);
        }
      }

      if (this.dialogStatus === 'create') {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'holidays',
              method: 'put',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      } else {
        // 编辑操作同样适用
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'holidays/' + this.formModel.StrID,
              method: 'patch',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      }
    },

    convertToLocalDate(utcDateStr) {
      // 解析 UTC 时间，确保输入格式正确（例如 "2025-02-28T00:00:00Z"）
      const date = new Date(utcDateStr);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", utcDateStr);
        return ""; // 如果解析失败，返回空字符串
      }
      // 转换为东八区时间，增加 8 小时（8 * 60 * 60 * 1000 毫秒）
      const localDate = new Date(date.getTime() + 8 * 60 * 60 * 1000);
      // 使用 UTC 方法提取东八区时间的年、月、日
      const year = localDate.getUTCFullYear();
      const month = String(localDate.getUTCMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需 +1
      const day = String(localDate.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; // 返回格式化的东八区日期
    },
    handleUpdate(row) {
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
      // this.formModel = {
      //   ...row,
      //   DTStartTime: row.DTStartTime.split('T')[0],
      //   DTEndTime: row.DTEndTime.split('T')[0]
      // };
      this.formModel = {
        ...row, // 保留其他字段
        DTStartTime: this.convertToLocalDate(row.DTStartTime), // 转换开始时间
        DTEndTime: this.convertToLocalDate(row.DTEndTime) // 转换结束时间
      };
    },
    handleDelete(row) {
      this.$confirm('确定要删除假期吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$axios({
          url: BASE_URL + 'holidays/' + row.StrID,
          method: 'delete',
          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem("token")
          }
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: '删除成功',
              type: 'success',
              duration: 2000
            });
          } else {
            this.$notify({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    }
  }
};
</script>